import ApiService from "../../Services/ApiService";

export default {
  state: {
    insiders: [],
    recentInsiders: []
  },

  getters: {
    getInsiders: (state) => (company_id) => {
      return state.insiders.find((s) => s.company_id === company_id);
    },
    getRecentInsiders(state) {
      return state.recentInsiders;
    }
  },

  mutations: {
    setInsiders(state, item) {
      state.insiders.push(item);
    },
    setRecentInsiders(state, payload) {
      state.recentInsiders = payload;
    }
  },

  actions: {
    async loadRecentInsiders({ commit }, data) {
      const insiderTrades = (await ApiService.fetchRecentInsiders(data)).data;

      commit('setRecentInsiders', insiderTrades);
    }
  },
};
